<template>
  <div
    v-if="store"
    class="mb-4"
  >
    <smpw-map
      :center="mapCenter"
    >
      <smpw-map-marker
        :title="store.name"
        :position="mapCenter"
        :read-only="readOnly"
        :scale="1.3"
        @update:position="updateLocation"
      />
    </smpw-map>

    <div
      v-if="!readOnly"
      class="mt-5"
    >
      <v-text-field
        v-model="store.lat"
        :label="t('location.latitude')"
        disabled
      />
      <v-text-field
        v-model="store.lng"
        :label="t('location.longitude')"
        disabled
      />
    </div>
    <localizer-dialog
      v-if="!readOnly"
      icon="map-pin"
      :button-text="t('location.search_move')"
      @update:location="updateLocationFromLocalizer"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import SmpwMap from '@/components/globals/SmpwMap.vue';
import SmpwMapMarker from '@/components/globals/SmpwMapMarker.vue';
import { useSettings } from '@/composables';
import LocalizerDialog from '../dialogs/LocalizerDialog.vue';

withDefaults(defineProps<{
  readOnly?: boolean;
}>(), {
  readOnly: () => false,
});

const { t } = useI18n();
const { getSetting } = useSettings();

const store = defineModel<any>();

function updateLocationFromLocalizer(e: Position): void {
  store.value.lat = e.lat;
  store.value.lng = e.lng;
}
function updateLocation(e: google.maps.MapMouseEvent): void {
  if (!e.latLng) {
    return;
  }
  store.value.lat = e.latLng.lat();
  store.value.lng = e.latLng.lng();
}

const mapCenter = computed(() => ({
  lng: store.value.lng || getSetting('city_centre_lng'),
  lat: store.value.lat || getSetting('city_centre_lat'),
}));
</script>
